"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationItemDtoNotificationTypeEnum = exports.NotificationItemDtoUserTypeEnum = void 0;
exports.instanceOfNotificationItemDto = instanceOfNotificationItemDto;
exports.NotificationItemDtoFromJSON = NotificationItemDtoFromJSON;
exports.NotificationItemDtoFromJSONTyped = NotificationItemDtoFromJSONTyped;
exports.NotificationItemDtoToJSON = NotificationItemDtoToJSON;
exports.NotificationItemDtoToJSONTyped = NotificationItemDtoToJSONTyped;
/**
 * @export
 */
exports.NotificationItemDtoUserTypeEnum = {
    Vendor: 'vendor',
    Admin: 'admin',
    Agent: 'agent',
    Buyer: 'buyer'
};
/**
 * @export
 */
exports.NotificationItemDtoNotificationTypeEnum = {
    Offer: 'offer',
    Auction: 'auction',
    Enquiry: 'enquiry',
    Custom: 'custom'
};
/**
 * Check if a given object implements the NotificationItemDto interface.
 */
function instanceOfNotificationItemDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('user_type' in value) || value['user_type'] === undefined)
        return false;
    if (!('notification_type' in value) || value['notification_type'] === undefined)
        return false;
    if (!('is_read' in value) || value['is_read'] === undefined)
        return false;
    if (!('created_at' in value) || value['created_at'] === undefined)
        return false;
    return true;
}
function NotificationItemDtoFromJSON(json) {
    return NotificationItemDtoFromJSONTyped(json, false);
}
function NotificationItemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'user_id': json['user_id'] == null ? undefined : json['user_id'],
        'user_type': json['user_type'],
        'subject': json['subject'] == null ? undefined : json['subject'],
        'message': json['message'] == null ? undefined : json['message'],
        'notification_type': json['notification_type'],
        'listing_id': json['listing_id'] == null ? undefined : json['listing_id'],
        'offer_id': json['offer_id'] == null ? undefined : json['offer_id'],
        'bid_id': json['bid_id'] == null ? undefined : json['bid_id'],
        'contract_document_id': json['contract_document_id'] == null ? undefined : json['contract_document_id'],
        'payment_receipt_id': json['payment_receipt_id'] == null ? undefined : json['payment_receipt_id'],
        'enquiry_id': json['enquiry_id'] == null ? undefined : json['enquiry_id'],
        'deep_link': json['deep_link'] == null ? undefined : json['deep_link'],
        'is_read': json['is_read'],
        'created_at': json['created_at'],
    };
}
function NotificationItemDtoToJSON(json) {
    return NotificationItemDtoToJSONTyped(json, false);
}
function NotificationItemDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'user_id': value['user_id'],
        'user_type': value['user_type'],
        'subject': value['subject'],
        'message': value['message'],
        'notification_type': value['notification_type'],
        'listing_id': value['listing_id'],
        'offer_id': value['offer_id'],
        'bid_id': value['bid_id'],
        'contract_document_id': value['contract_document_id'],
        'payment_receipt_id': value['payment_receipt_id'],
        'enquiry_id': value['enquiry_id'],
        'deep_link': value['deep_link'],
        'is_read': value['is_read'],
        'created_at': value['created_at'],
    };
}
